import React, { useRef, useEffect } from "react";
import { Box, Input, Center, VStack, Text, HStack } from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";
import { Icon } from "@chakra-ui/react";
import { socket } from "../service/socket";
//      <Icon as={FiSend} color="#3E9FA5" w={20} h={20} onClick={() => {}} />

export default function FirstScreen({ setUsernameHandler }) {
  const inp = useRef();
  return (
    <Box w="100%" h="100%">
      <VStack h="100%" justify="center">
        <Box textAlign="center">
          {" "}
          <Text
            fontFamily="monospace"
            color="#3E9FA5"
            fontWeight="bold"
            fontSize={{ base: "5xl", md: "6xl" }}
          >
            Chato
          </Text>
        </Box>
        <Box>
          {" "}
          <Text
            fontFamily="monospace"
            color="#3E9FA5"
            fontSize={{ base: "3xl", md: "4xl" }}
          >
            Anonymous, Secure, Fast
          </Text>
        </Box>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setUsernameHandler(inp.current.value);
            socket.emit("loged user", inp.current.value);
          }}
        >
          <Input
            p={8}
            fontSize={{ base: "2xl", md: "3xl" }}
            ref={inp}
            placeholder="Enter your name"
          />{" "}
        </form>
      </VStack>
    </Box>
  );
}
